import { forwardRef, type Ref, type SVGProps } from "react";
const IconFileSpreadsheetOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M26 8.59 20.41 3A3.73 3.73 0 0 0 18 2H7a2.006 2.006 0 0 0-2 2v24a2.006 2.006 0 0 0 2 2h18a2.006 2.006 0 0 0 2-2V11a3.73 3.73 0 0 0-1-2.41m-7-4.18L24.59 10H19ZM25 28H7V4h10v7a1 1 0 0 0 1 1h7Z"
    />
    <path
      fill="currentColor"
      d="M21.5 14h-11A1.5 1.5 0 0 0 9 15.5v9a1.5 1.5 0 0 0 1.5 1.5h11a1.5 1.5 0 0 0 1.5-1.5v-9a1.5 1.5 0 0 0-1.5-1.5M15 18h6v2h-6Zm-2 6h-2v-2h2Zm0-4h-2v-2h2Zm8 4h-6v-2h6Z"
    />
  </svg>
);
const ForwardRef = forwardRef(IconFileSpreadsheetOutlineSVG);
ForwardRef.displayName = "IconFileSpreadsheetOutline";
export { ForwardRef as IconFileSpreadsheetOutline };
